import React from 'react';
//scss
import './Header.scss';
//anime
import anime from 'animejs';
//icons
import ZigZag from '../Icons/zigzag';
import Triangle from '../Icons/triangle';
import Wave from '../Icons/wave';
import SkewRec from '../Icons/skewRec';
import Diamond from '../Icons/diamond';
import HalfCircle from '../Icons/halfCircle';

class Header extends React.Component {
  componentDidMount() {
    // Create a timeline with default parameters
    let animation = anime.timeline({
      easing: 'easeOutExpo',
      duration: 350,
    });
    // Add children
    animation
      .add({
        targets: '.Header_title_1',
        scale: 1.1,
        color: '#f98664',
      })
      .add({
        targets: '.Header_title_1',
        scale: 1,
        color: '#7370a3',
      })
      .add({
        targets: '.Header_title_2',
        scale: 1.1,
        color: '#f98664',
      })
      .add({
        targets: '.Header_title_2',
        scale: 1,
        color: '#7370a3',
      })
      .add({
        targets: '.Header_title_3',
        scale: 1.1,
        color: '#f98664',
      })
      .add({
        targets: '.Header_title_3',
        scale: 1,
        color: '#7370a3',
      });
  }
  onHoverOn = e => {
    anime({
      targets: `.${e.target.className}`,
      scale: 1.1,
      color: '#f98664',
    });
  };

  onHoverOut = e => {
    anime({
      targets: `.${e.target.className}`,
      scale: 1,
      color: '#7370a3',
    });
  };
  render() {
    return (
      <div className="headerWrapper">
        <div className="Header">
          <div className="Header_title">
            <div
              className="Header_title_1"
              onMouseEnter={e => this.onHoverOn(e)}
              onMouseLeave={e => this.onHoverOut(e)}
            >
              ART
            </div>
            <div
              className="Header_title_2"
              onMouseEnter={e => this.onHoverOn(e)}
              onMouseLeave={e => this.onHoverOut(e)}
            >
              DESIGN
            </div>
            <div
              className="Header_title_3"
              onMouseEnter={e => this.onHoverOn(e)}
              onMouseLeave={e => this.onHoverOut(e)}
            >
              CODE
            </div>
          </div>
          <ZigZag />
          <Triangle />
          <Wave />
          <HalfCircle />
        </div>
      </div>
    );
  }
}

export default Header;
